import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'

import Particles from '@tsparticles/vue3';
import { loadFull } from 'tsparticles';

import { getAuth, signInAnonymously } from 'firebase/auth';
import { initializeApp } from 'firebase/app';
import axios from 'axios';

import firebaseConfig from '@/assets/FirebaseConfig.json';

import pageStyles from '@/styles/page.module.css';

const fbApp = initializeApp(firebaseConfig);
const auth = getAuth(fbApp);

const instance = axios.create({
  baseURL: window.location.origin + '/ffapi',
  timeout: 10000
}); 

instance.interceptors.request.use(async (config) => {
  if (!auth.currentUser) signInAnonymously(auth);
  const idToken = auth.currentUser ? await auth.currentUser.getIdToken() : null;

  config.headers.Authorization = `Bearer ${idToken}`;

  return config;
});

loadFonts()

const app = createApp(App);

app.config.globalProperties.$auth = auth;
app.config.globalProperties.$api = instance;
app.config.globalProperties.$ps = pageStyles;

app
  .use(router)
  .use(vuetify)
  .use(Particles, {
    init: async engine => {
      await loadFull(engine);
    }
  })
  .mount('#app');
